import React from 'react';
import { CalendarClock } from 'lucide-react';
import { Button } from 'components/ui/button';
import { useAGLOCampaign } from 'hooks/useAGLOCampaign';

const HistoricalCampaignStrip = () => {
  const {
    campaignYear,
    selectedCampaignYear,
    isHistoricalCampaign,
    isCampaignSwitching,
    writesInProgress,
    setSelectedCampaignYear,
  } = useAGLOCampaign();
  if (!isHistoricalCampaign) return null;
  return (
    <div
      role="status"
      className="mb-5 flex flex-col gap-3 rounded-lg border border-[#c8dfd0] bg-[#f0f7f2] px-3.5 py-3 text-sm text-[#405d49] sm:flex-row sm:items-center sm:justify-between sm:gap-4"
    >
      <div className="flex min-w-0 items-start gap-2.5">
        <CalendarClock className="mt-0.5 size-[18px] shrink-0 text-[#28764d]" aria-hidden="true" />
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <strong className="font-semibold text-[#244c34]">Campagne {selectedCampaignYear}</strong>
            <span className="rounded-full border border-[#c8dfd0] bg-white px-2 py-0.5 text-[11px] font-medium leading-4 text-[#3d6850]">
              Lecture seule
            </span>
          </div>
          <p className="mt-0.5 text-xs leading-5 text-[#536b5a]">Vous consultez une campagne antérieure.</p>
        </div>
      </div>
      <Button
        variant="outline"
        size="sm"
        className="h-8 shrink-0 self-start border-[#b9d2c2] bg-white px-3 text-xs font-medium text-[#18543b] hover:bg-[#e5f1e8] sm:self-center"
        disabled={isCampaignSwitching || writesInProgress > 0}
        onClick={() => setSelectedCampaignYear(campaignYear)}
      >
        Revenir à la campagne {campaignYear}
      </Button>
    </div>
  );
};

export default HistoricalCampaignStrip;
